import { useEffect, useEffectEvent, useState } from 'react';

export const useHasSufficientViewportHeight = () => {
  const [hasSufficientViewportHeight, setHasSufficientViewportHeight] =
    useState(() => globalThis.matchMedia(`(min-height: 900px)`).matches);

  const handleChange = useEffectEvent((event: MediaQueryListEvent) =>
    setHasSufficientViewportHeight(event.matches),
  );

  useEffect(() => {
    const mediaQuery = globalThis.matchMedia(`(min-height: 900px)`);
    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return hasSufficientViewportHeight;
};
